import React, { Fragment } from 'react';
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Popover,
  Select,
} from '@material-ui/core';

import styles from './styles';
import { useTranslation } from 'react-i18next';

interface RBISelectButtonInterface {
  onChangeInput: (event: React.ChangeEvent<{ value: unknown }>) => void;
  handleApplyButton: (name: string | undefined, value: any) => void;
  handleOnClosePopUp?: () => void;
  valueOption: string;
  id: string;
  width?: number;
  labelText: string;
  options: any[];
  style?: any;
  disabled?: boolean;
  ellipsisLabelText?: boolean;
}

const RBISelectButton = ({
  labelText,
  onChangeInput,
  handleApplyButton,
  handleOnClosePopUp,
  valueOption,
  id,
  options,
  width = 180,
  style = {},
  disabled = false,
  ellipsisLabelText = false,
}: RBISelectButtonInterface) => {
  const classes = styles();
  const [anchorElPopover, setAnchorElPopover] =
    React.useState<HTMLElement | null>(null);

  const handlePopoverOpen = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
  ) => {
    setAnchorElPopover(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorElPopover(null);
    handleOnClosePopUp && handleOnClosePopUp();
  };

  const onApplyButton = () => {
    handleApplyButton(id, valueOption);
    handlePopoverClose();
  };

  const { t } = useTranslation();

  return (
    <Fragment>
      <Button
        variant="outlined"
        classes={{
          label: classes.availabilityFilterLabel,
          root: classes.availabilityButton,
        }}
        onClick={handlePopoverOpen}
        disabled={disabled}
      >
        {labelText}
      </Button>
      <Popover
        open={Boolean(anchorElPopover)}
        onClose={handlePopoverClose}
        anchorEl={anchorElPopover}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        classes={{
          paper: `${classes.searchButtonPopover} `,
        }}
      >
        <div className={`${classes.flexSpaceBetween} ${classes.alignCenter}`}>
          <FormControl
            size="small"
            variant="outlined"
            className={classes.formControlRightFilters}
          >
            <InputLabel
              id={`label-${id}`}
              className={`${classes.popoverLabelText} ${
                ellipsisLabelText ? classes.popoverLabelTextEllipsis : ''
              }`}
            >
              {labelText}
            </InputLabel>
            <Select
              labelId={`label-${id}`}
              id={id}
              value={valueOption}
              name={id}
              onChange={onChangeInput}
              style={{ width: width }}
              variant="outlined"
            >
              {options.map((option, index) => (
                <MenuItem key={index} value={option.value}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            className={classes.buttonApply}
            size="small"
            variant="contained"
            color="primary"
            onClick={onApplyButton}
          >
            {t('app.common.filter')}
          </Button>
        </div>
      </Popover>
    </Fragment>
  );
};

export default RBISelectButton;
